<template>
  <div class="about">
    <!-- <h1>Registered pilots</h1> -->
    <PilotList></PilotList>
  </div>
</template>

<script>
// @ is an alias to /src
import PilotList from '@/components/airbox/PilotList.vue'

export default {
  name: 'Lsb',
  data () {
    return {
      startInput: 0
    }
  },
  components: {
    PilotList
  }
}
</script>